import React, { ReactNode } from "react";
import { Button, Modal, ButtonProps } from "antd";

interface ReusableModalProps {
  modalOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void | Promise<void>;
  title: string;
  description: ReactNode;
  icon: string;
  confirmText: React.ReactNode;
  cancelText: string;
  confirmButtonProps?: ButtonProps;
  cancelButtonProps?: ButtonProps;
}

const ReusableModal: React.FC<ReusableModalProps> = ({
  modalOpen,
  onCancel,
  onConfirm,
  title,
  description,
  icon,
  confirmText,
  cancelText,
  confirmButtonProps,
  cancelButtonProps,
}) => {
  return (
    <Modal
      className="confirmation-modal-content"
      centered
      open={modalOpen}
      footer={null}
      onCancel={onCancel}
    >
      <div className="confirmation-modal-wrapper">
        <div className="confirmation-modal-header">
          <img src={icon} className="confirmation-Icon" alt="Modal Icon" />
          <label className="popup-msg-content">{title}</label>
        </div>
        <div className="confirmation-modal-body">
          <span>{description}</span>
        </div>
        <div className="confirmation-modal-footer">
          <Button 
          key="confirm" 
          className="button button--danger" 
          onClick={onConfirm}
          {...confirmButtonProps}
          >
          
            {confirmText}
          </Button>
          <Button key="cancel" className="button button--outline" onClick={onCancel}  {...cancelButtonProps}>
            {cancelText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ReusableModal;
